import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./clients.css";
import { useTranslation } from "react-i18next";

import egov from "../img/logos/Egov.png";
import circuit from "../img/logos/Baku city circuit.png";
import ddlar from "../img/logos/DDLAR İnşaat.png";
import pozitron from "../img/logos/pozitron .png";
import gbl from "../img/logos/gbl.png";
import yves from "../img/logos/yves rocher.png";
import mayoral from "../img/logos/mayoral.png";
import nargiz from "../img/logos/Nargiz Mall.png";
import oxybul from "../img/logos/oxybul.png";
import jacadi from "../img/logos/jacadi.png";
import hyatt from "../img/logos/Hyatt regency .png";
import hilton from "../img/logos/hilton.png";
import radisson from "../img/logos/radisson.png";
import costa from "../img/logos/Costa Coffee.png";
import isr from "../img/logos/isr plaza .png";
import gilan from "../img/logos/gilan .png";
import ineo from "../img/logos/ineo.png";
import azfit from "../img/logos/azfit.png";
import cop from "../img/logos/COP 29.png";
import login from "../img/logos/Login İnternational Logistics.png";
import Electrify from "../img/logos/Electrify Azerrbaijan.png";
import Sarda from "../img/logos/Sarda Group.png";
import CIG from "../img/logos/CIG.png";
import CIGContainers from "../img/logos/CIG Containers.png";





const clients = [
  { id: 1, img: egov, name: "Elektron Hökumətin İnkişafı Mərkəzi" },
  { id: 2, img: circuit, name: "Bakı Şəhər Halqası Əməliyyat Şirkəti" },
  { id: 3, img: costa, name: "Costa Coffe" },
  { id: 6, img: yves, name: "Yves Rocher Azerbaijan" },
  { id: 7, img: mayoral, name: "Mayoral Azerbaijan" },
  { id: 8, img: oxybul, name: "Oxybul Azerbaijan" },
  { id: 9, img: jacadi, name: "Jacadi Azerbaijan" },
  { id: 11, img: hyatt, name: "Hyatt Regency" },
  { id: 12, img: hilton, name: "Hilton Baku" },
  { id: 13, img: ddlar, name: "DDLAR Group" },
  { id: 14, img: radisson, name: "Radisson Baku Hotel" },
  { id: 15, img: CIGContainers, name: "CIG Containers" },
  { id: 16, img: ineo, name: "İneo" },
  { id: 18, img: nargiz, name: "Nargiz Mall" },
  { id: 19, img: azfit, name: "AZFIT" },
  { id: 20, img: cop, name: "COP-29 Baku Azerbaijan" },
  { id: 21, img: login, name: "Login International Logistics" },
  { id: 22, img: Electrify, name: "Electrify Azerbaijan" },
  { id: 23, img: Sarda, name: "Sarda Group" },
  { id: 24, img: CIG, name: "CIG" },
  { id: 25, img: isr, name: "İsr Plaza" },


];

const Clients = () => {
  const { t, i18n } = useTranslation();
  const settings = {
    infinite: true, // Бесконечная прокрутка
    speed: 500, // Скорость анимации
    slidesToShow: 8, // Количество отображаемых элементов
    slidesToScroll: 1, // Прокрутка по одному элементу
    autoplay: true, // Автоматическая прокрутка
    autoplaySpeed: 2000, // Скорость прокрутки
    responsive: [
      {
        breakpoint: 1024, // Для больших экранов
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768, // Для планшетов
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480, // Для мобильных
        settings: { slidesToShow: 1 },
      },
    ],
    arrows: true, // Стрелки
  };

  return (
    <div className="bg-white py-10">
      {/* <h2 className="text-white text-2xl font-bold text-center mb-6">
        {t("clients_header")}
      </h2> */}
      <div className="max-w-full mx-auto px-28">
        <Slider
          {...settings}
          className="relative"
        >
          {clients.map((client) => (
          <div key={client.id} className="text-center">
          <div className="flex flex-col items-center">
            <div className="w-28 h-28 md:w-32 md:h-32 rounded-full  flex items-center justify-center">
              <img
                src={client.img}
                alt={client.name}
                className="w-24 h-24 md:w-28 md:h-28 object-cover rounded-full p-1 bg-gradient-to-r from-primary  to-primaryDark"

              />
            </div>
            {/* <p className="text-white mt-4 text-sm md:text-base">{client.name}</p> */}
          </div>
        </div>
        
          ))}
        </Slider>
      </div>
      <style jsx global>{`
        .slick-prev,
        .slick-next {
          z-index: 2;
          top: 50%;
          transform: translate(0, -50%);
        }
        .slick-prev {
          left: -20px;
        }
        .slick-next {
          right: -20px;
        }
        @media (max-width: 768px) {
          .slick-prev {
            left: -10px;
          }
          .slick-next {
            right: -10px;
          }
        }
      `}</style>
    </div>
  );
};

export default Clients;
